/**
 * @generated SignedSource<<b08413110aadad6d236b379df39ca02d>>
 * @relayHash 1c0c8d9f3383205c133bf90aba7336a5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1c0c8d9f3383205c133bf90aba7336a5

import type { ConcreteRequest } from 'relay-runtime';
export type DependenciesPickerBlockedByIssuesQuery$variables = {
  id: string;
};
export type DependenciesPickerBlockedByIssuesQuery$data = {
  readonly node: {
    readonly blockedBy?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
      } | null | undefined> | null | undefined;
    };
    readonly id?: string;
  } | null | undefined;
};
export type DependenciesPickerBlockedByIssuesQuery = {
  response: DependenciesPickerBlockedByIssuesQuery$data;
  variables: DependenciesPickerBlockedByIssuesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100
    }
  ],
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blockedBy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "blockedBy(first:100)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DependenciesPickerBlockedByIssuesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DependenciesPickerBlockedByIssuesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1c0c8d9f3383205c133bf90aba7336a5",
    "metadata": {},
    "name": "DependenciesPickerBlockedByIssuesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9acf397a97092abf8a3597316557062d";

export default node;
